import { getService } from 'data/function';
import { EventAction } from '../EventAction';
import { catchAction } from '../EventReceiver';
export class PermissionsProcessor {
    static get PermissionsService() {
        return getService('PermissionsService');
    }
    static async process({ message, trackingProperties, source }) {
        let response;
        switch (catchAction(message.action)) {
            case EventAction.HasPermissions:
                response = await this.hasPermissions(message);
                break;
            case EventAction.GetPermissionsObject:
                response = await this.PermissionsService.getPermissionsObject();
                break;
        }
        source.postMessage({
            response,
            trackingProperties,
        }, '*');
    }
    static hasPermissions(message) {
        const { permissionType, customArea, customShortName } = message.content;
        return this.PermissionsService.hasPermissions(permissionType, customArea, customShortName);
    }
}
